// tslint:disable:max-line-length
import {IconButton, Typography, withStyles, WithStyles} from "@material-ui/core";
import {getCampaignToken} from '@services/user/user.actions';
import * as React from "react";
import {FormEvent} from "react";
import Button from "@components/common/button/Button";
import TranslateNew from "@translate/TranslateNew";
import {SignupStyle} from "@components/signup/signup.style";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import Input from "@components/common/input/input.component";
import {HideShowPassword} from "@images/HideShowPassword";
import {connect} from "react-redux";
import ProgressBar from "@components/common/progressBar/progressBar";
import CornerRightElements2 from "@components/svg/cornerRightElements2";
import SelectLanguage from "@components/common/language/SelectLanguage";
import { Link } from "react-router-dom";
import { IUserCreate } from "@app-types/api/user.types";
import cordovaContext from "src/cordovaContext";
import { CountryDetection } from "@helpers/countryDetection";

const tn: TranslateNew = TranslateNew.getInstance();

export interface IFormValues {
    token: string;
    email: string;
    newPassword: string;
    firstName: string;
    lastName: string;
    // language: string;
}

interface ISignupProps extends WithStyles<typeof SignupStyle> {
    onSubmit: (values: IUserCreate) => void;
    onValidateInviteToken?: (token: string) => void;
    getCampaignToken: (email:string) => void;
    getInviteToken: (email:string) => void;
    initialValues: IFormValues;
    language: string;
    timezone: string;
    isLoading?: boolean;
    benefactor?: string;
    campaignToken?: string;
}

interface IState {
    showPassword: boolean;
    formValues: IFormValues;
    isFocus:boolean;
    formErrors: {
        token?: string | undefined,
        email?: string | undefined,
        newPassword?: string | undefined,
        firstName?: string | undefined,
        lastName?: string | undefined,
    };
    showInvite: boolean;
    signupType?: "invite" | "new";
}

export class Signup extends React.Component<ISignupProps, IState> {
    public static defaultProps = {
        initialValues: {
            token: "", email: "", newPassword: "", firstName: "", lastName: "", language: "EN",
        }, isLoading: false,
    };

    constructor(props: ISignupProps) {
        super(props);

        this.state = {
            showPassword: false, showInvite: (props.initialValues.token.length > 0), isFocus: false,
            signupType: (props.initialValues.token.length > 0 ? "invite" : undefined),
            formValues: {...props.initialValues}, formErrors: {
                token: undefined, email: undefined, newPassword: undefined, firstName: undefined, lastName: undefined,
            },
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleInputBlur = this.handleInputBlur.bind(this);
        this.validateEmail = this.validateEmail.bind(this);
        this.validatePassword = this.validatePassword.bind(this);
        this.validateFirstName = this.validateFirstName.bind(this);
        this.validateLastName = this.validateLastName.bind(this);
        this.validateToken = this.validateToken.bind(this);
    }

    public componentDidUpdate(oldProps: ISignupProps) {
        if (oldProps.initialValues !== this.props.initialValues) {
            const initialValues:IFormValues = JSON.parse(JSON.stringify(this.props.initialValues));
            // Invite/campaign lookups must not clear a typed or generated password.
            initialValues.newPassword = this.state.formValues.newPassword;
            if (this.state.formValues.email.length > 5) {
                initialValues.email = this.state.formValues.email;
            }
            if (this.state.formValues.firstName.length > 1) {
                initialValues.firstName = this.state.formValues.firstName;
            }
            if (this.state.formValues.lastName.length > 1) {
                initialValues.lastName = this.state.formValues.lastName;
            }
            if (this.state.formValues.token.length > 3) {
                initialValues.token = this.state.formValues.token;
            }
            if (this.state.signupType === "new") {
                initialValues.token = "";
            }
            this.setState({
                formValues: initialValues,
                showInvite: (this.state.signupType === "invite" || initialValues.token.length > 3),
                signupType: (initialValues.token.length > 3 && this.state.signupType !== "new"
                    ? "invite"
                    : this.state.signupType),
            });
        }
        if (oldProps.language !== this.props.language) {
            const initialValues = JSON.parse(JSON.stringify(this.props.initialValues));
            if (this.props.language !== undefined) {
                initialValues.language = this.props.language;
            }

            this.setState((prevState) => ({formValues: {...prevState.formValues, language: initialValues.language}}));
        }
    }

    public render() {
        const {formErrors, formValues} = this.state;
        const {isLoading, benefactor} = this.props;
        const style = this.props.classes;
        const isCordovaApp = this.context;

        return (<div className={style.root}>
            <div className={style.background} style={(this.state.isFocus && isCordovaApp)?{paddingBottom:'300px'}:{}}>
                <div className={style.circle}/>
                <CornerRightElements2 viewBox="-40 10 219 212" className={style.backgroundImgCornerTopRight}/>
                {isLoading && (<ProgressBar variant="indeterminate"/>)}
            </div>
            <div className={style.languageSelect}>
                <SelectLanguage/>
            </div>
            <div className={style.container}>
                <div className={style.topBar}>
                    {this.state.signupType === undefined ? (
                        <Link to='/' style={{textDecoration: 'none'}}>
                            <Button variant="text" className={style.backButton} disabled={isLoading}>
                                <ArrowBackIcon fontSize="inherit"/>
                                <span>{tn.lang.back}</span>
                            </Button>
                        </Link>
                    ) : (
                        <Button
                            variant="text"
                            className={style.backButton}
                            disabled={isLoading}
                            onClick={this.handleBackToSignupType}
                        >
                            <ArrowBackIcon fontSize="inherit"/>
                            <span>{tn.lang.back}</span>
                        </Button>
                    )}
                </div>
                <div className={style.centerContent}>
                    <div className={style.topContent}>
                        {this.state.signupType !== undefined && (
                            <Typography variant="h2">{tn.lang.signUpTitle}</Typography>
                        )}
                        <Typography style={{marginTop: '-20px', fontStyle: 'italic', transition: 'all 0.2s', 
                            opacity:((benefactor && !this.state.showInvite)?1:0), maxHeight: ((benefactor && !this.state.showInvite)?100:0)}}>
                            {tn.lang.signupCampaign}<br/>{benefactor}
                        </Typography>
                    </div>
                    {this.state.signupType === undefined ? (
                        <div className={style.signupTypeContent}>
                            <Typography variant="h5" className={style.signupTypeQuestion}>
                                {tn.lang.signUpInviteQuestion}
                            </Typography>
                            <div className={style.signupTypeActions}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="large"
                                    fullWidth={true}
                                    disabled={isLoading}
                                    onClick={this.handleJoinGroup}
                                >
                                    {tn.lang.signUpJoinGroupButton}
                                </Button>
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    size="large"
                                    fullWidth={true}
                                    disabled={isLoading}
                                    onClick={this.handleStartNewGroup}
                                >
                                    {tn.lang.signUpStartNewGroupButton}
                                </Button>
                            </div>
                        </div>
                    ) : (<form className={style.form} autoComplete="on" onSubmit={this.handleSubmit}>
                        <div className={style.formMiddleContent}>
                            {this.state.showInvite && (<Input
                                    id="token"
                                    name="token"
                                    type="text"
                                    onChange={this.handleInputChange}
                                    onBlur={this.handleInputBlur}
                                    value={formValues.token}
                                    placeholder={tn.lang.placeholderInviteToken}
                                    error={formErrors.token}
                                    disabled={isLoading}
                                />)}
                            <Input
                                id="firstName"
                                name="firstName"
                                type="text"
                                autoComplete="given-name"
                                onChange={this.handleInputChange}
                                onBlur={this.handleInputBlur}
                                value={formValues.firstName}
                                label={tn.lang.labelFirstName}
                                error={formErrors.firstName}
                                disabled={isLoading}
                            />
                            <Input
                                id="lastName"
                                name="lastName"
                                type="text"
                                autoComplete="family-name"
                                onFocus={() => this.setState({isFocus:true})}
                                onChange={this.handleInputChange}
                                onBlur={this.handleInputBlur}
                                value={formValues.lastName}
                                label={tn.lang.labelSirName}
                                error={formErrors.lastName}
                                disabled={isLoading}
                            />
                            <Input
                                type="email"
                                name="email"
                                id="email"
                                label={tn.lang.labelEmail}
                                autoComplete="username"
                                autoCapitalize="none"
                                autoCorrect="off"
                                spellCheck={false}
                                onFocus={() => this.setState({isFocus:true})}
                                value={formValues.email}
                                onChange={this.handleInputChange}
                                onBlur={this.handleInputBlur}
                                error={formErrors.email}
                                disabled={isLoading}
                            />
                            <Input
                                name="newPassword"
                                id="newPassword"
                                type={this.state.showPassword ? "text" : "password"}
                                autoComplete="new-password"
                                label={tn.lang.labelPassword}
                                value={formValues.newPassword}
                                onFocus={() => this.setState({isFocus:true})}
                                onChange={this.handleInputChange}
                                onBlur={this.handleInputBlur}
                                error={formErrors.newPassword}
                                disabled={isLoading}
                            >
                                <IconButton
                                    size="small"
                                    disabled={isLoading}
                                    onClick={() => this.setState({showPassword: !this.state.showPassword})}
                                >
                                    <HideShowPassword fill={this.state.showPassword ? '#9A8C9A' : '#242424'}/>
                                </IconButton>
                            </Input>
                        </div>
                        <div className={style.formBottomContent}>
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                size="large"
                                fullWidth={true}
                                disabled={isLoading}
                            >
                                {tn.lang.signUpButton}
                            </Button>
                            <Typography variant="body2" className={style.termsNotice}>
                                {tn.lang.signupTermsNoticeStart}
                                <a
                                    href={tn.lang.termsOfUseUrl}
                                    className={style.termsNoticeLink}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    onClick={(e) => { e.preventDefault(); this.openExternalLink(tn.lang.termsOfUseUrl); }}
                                >
                                    {tn.lang.termsOfUseLinkText}
                                </a>
                                {tn.lang.signupTermsNoticeMiddle}
                                <a
                                    href={tn.lang.privacyPolicyUrl}
                                    className={style.termsNoticeLink}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    onClick={(e) => { e.preventDefault(); this.openExternalLink(tn.lang.privacyPolicyUrl); }}
                                >
                                    {tn.lang.privacyPolicyLinkText}
                                </a>
                                .
                            </Typography>
                        </div>
                    </form>)}
                </div>
            </div>
        </div>);
    }


    private openExternalLink = (url: string) => {
        const w: any = window;
        if (w.cordova?.InAppBrowser) {
            w.cordova.InAppBrowser.open(url, "_system", "location=yes");
        } else {
            window.open(url, "_blank", "noopener");
        }
    }

    private validateToken = (): boolean => {
        const {formValues} = this.state;

        if (this.state.showInvite && !formValues.token) {
            this.setState((prevState) => ({
                formErrors: {
                    ...prevState.formErrors, token: tn.lang.validationInvitationCodeRequired,
                },
            }));
            return false;
        }

        if (formValues.token) {
            if (formValues.token.length < 5) {
                this.setState((prevState) => ({
                    formErrors: {
                        ...prevState.formErrors, token: tn.lang.validationInvitationCode,
                    },
                }));
                return false;
            }
        }

        this.setState((prevState) => ({
            formErrors: {
                ...prevState.formErrors, token: undefined,
            },
        }));
        return true;
    }

    private validateFirstName = (): boolean => {
        const {formValues} = this.state;

        if (!formValues.firstName) {
            this.setState((prevState) => ({
                formErrors: {
                    ...prevState.formErrors, firstName: tn.lang.validationFirstNameRequired,
                },
            }));
            return false;
        } else if (formValues.firstName.length < 2) {
            this.setState((prevState) => ({
                formErrors: {
                    ...prevState.formErrors, firstName: tn.lang.validationFirstNameInvalid,
                },
            }));
            return false;
        }

        this.setState((prevState) => ({
            formErrors: {
                ...prevState.formErrors, firstName: undefined,
            },
        }));
        return true;
    }

    private validateLastName = (): boolean => {
        const {formValues} = this.state;

        if (!formValues.lastName) {
            this.setState((prevState) => ({
                formErrors: {
                    ...prevState.formErrors, lastName: tn.lang.validationSirNameRequired,
                },
            }));
            return false;
        } else if (formValues.lastName.length < 2) {
            this.setState((prevState) => ({
                formErrors: {
                    ...prevState.formErrors, lastName: tn.lang.validationSirNameRequired,
                },
            }));
            return false;
        }

        this.setState((prevState) => ({
            formErrors: {
                ...prevState.formErrors, firstName: undefined,
            },
        }));
        return true;
    }

    private validateEmail = (): boolean => {
        const {formValues} = this.state;
        if (!formValues.email) {
            this.setState((prevState) => ({
                formErrors: {
                    ...prevState.formErrors, email: tn.lang.validationEmailRequired,
                },
            }));
            return false;
        } else if (!tn.testEmailIsValid(formValues.email)) {
            this.setState((prevState) => ({
                formErrors: {
                    ...prevState.formErrors, email: tn.lang.validationEmailNotValid,
                },
            }));
            return false;
        }

        this.setState((prevState) => ({
            formErrors: {
                ...prevState.formErrors, email: undefined,
            },
        }));
        return true;
    }

    private validatePassword = (): boolean => {
        const {formValues} = this.state;

        if (!formValues.newPassword) {
            this.setState((prevState) => ({
                formErrors: {
                    ...prevState.formErrors, newPassword: tn.lang.validationPasswordRequired,
                },
            }));
            return false;
        }

        this.setState((prevState) => ({
            formErrors: {
                ...prevState.formErrors, newPassword: undefined,
            },
        }));
        return true;
    }

    private handleSubmit = (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const email = event.currentTarget.elements.namedItem('email') as HTMLInputElement;
        const password = event.currentTarget.elements.namedItem('newPassword') as HTMLInputElement;
        const credentials = {email: email.value.trim(), newPassword: password.value};
        this.setState((prevState) => ({formValues: {...prevState.formValues, ...credentials}}), this.submitForm);
    }

    private submitForm = () => {
        const isFirstNameValid = this.validateFirstName();
        const isLastNameValid = this.validateLastName();
        const isEmailValid = this.validateEmail();
        const isPasswordValid = this.validatePassword();
        const isTokenValid = this.validateToken();

        if (isFirstNameValid && isLastNameValid && isEmailValid && isPasswordValid && isTokenValid) {
            const values:IUserCreate = {...this.state.formValues, 
                language: this.props.language, 
                campaign: this.props.campaignToken,
                timezone: this.props.timezone,
                country : CountryDetection.getCountryByTimeZone(),
                token: (this.state.formValues.token.length > 3
                    ?this.state.formValues.token
                    :undefined)};

            this.props.onSubmit(values);
        }
    }

    private handleInputBlur = (event: React.FormEvent<HTMLInputElement>) => {
        if (this.state.isFocus) {
            this.setState({isFocus:false});
        }
        const {name} = event.currentTarget;
        switch (name) {
            case 'token':
                this.validateToken();
                break;
            case 'firstName':
                this.validateFirstName();
                break;
            case 'lastName':
                this.validateLastName();
                break;
            case 'email':
                this.validateEmail();
                this.props.getCampaignToken(this.state.formValues.email.length > 0?this.state.formValues.email:"x");
                if (!(this.state.formValues.token && this.state.formValues.token.trim().length < 3)) {
                    if (this.state.formValues.email && this.state.formValues.email.length > 5) {
                        this.props.getInviteToken(this.state.formValues.email);
                    }
                }
                break;
            case 'newPassword':
                this.validatePassword();
                break;
        }
    }

    private handleJoinGroup = () => {
        this.setState({
            showInvite: true,
            signupType: "invite",
        });
    }

    private handleStartNewGroup = () => {
        this.setState((prevState) => ({
            showInvite: false,
            signupType: "new",
            formValues: {
                ...prevState.formValues,
                token: "",
            },
            formErrors: {
                ...prevState.formErrors,
                token: undefined,
            }
        }));
    }

    private handleBackToSignupType = () => {
        this.setState({
            showInvite: false,
            signupType: undefined,
        });
    }


    private handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const {name, value, type, checked} = event.target;
        const inputValue = type === 'checkbox' ? checked : (name === 'newPassword' ? value : value.trim());

        this.setState((prevState) => ({
            formValues: {
                ...prevState.formValues, [name]: inputValue,
            }, formErrors: {
                ...prevState.formErrors, [name]: undefined,
            }
        }));

        if (name === 'token' && typeof inputValue === 'string' && inputValue && inputValue.length >= 5 && this.props.onValidateInviteToken) {
            this.props.onValidateInviteToken(inputValue);
        }
    }
}

const mapDispatchToProps = {
    getCampaignToken,
  };

function mapStateToProps(state: any) {
    const language = state.user.language;
    const campaignToken: string|undefined = state.user?.session?.campaigns?.token;
    const campaigns: Array<{value: string, name: string}> | undefined  = state.user?.session?.campaigns?.campaigns;

    let benefactor;

    if (campaignToken && campaigns) { 
        if (campaignToken.toUpperCase() !== "WEB") {
            for (const campaign of campaigns) {
                if (campaign.value?.toUpperCase() === campaignToken.toUpperCase()) {
                    benefactor = campaign.name;
                }
            }
        }
    }

    const timezone:string = Intl.DateTimeFormat().resolvedOptions().timeZone;

    return {
        timezone,
        language,
        benefactor,
        campaignToken
    };
}

Signup.contextType = cordovaContext;

export default (withStyles(SignupStyle)(connect(mapStateToProps, mapDispatchToProps)(Signup)));



// WEBPACK FOOTER //
// ./src/components/signup/signup.component.tsx